import { render, staticRenderFns } from "./ProductOrderDetail.vue?vue&type=template&id=422c81ac&scoped=true&"
import script from "./ProductOrderDetail.vue?vue&type=script&lang=js&"
export * from "./ProductOrderDetail.vue?vue&type=script&lang=js&"
import style0 from "./ProductOrderDetail.vue?vue&type=style&index=0&id=422c81ac&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "422c81ac",
  null
  
)

export default component.exports